import gql from "graphql-tag";

export const ADD_ORDER_DISH = gql`
  mutation addOrderDish(
    $count: Int!
    $dishId: uuid!
    $modifierItems: [OrderDishModifierItem_insert_input!]!
  ) {
    insert_OrderDish(
      objects: {
        count: $count
        dishId: $dishId
        OrderDishModifierItems: { data: $modifierItems }
      }
    ) {
      returning {
        count
        createdAt
        dishId
        id
        Dish {
          name
          id
          price
          categoryId
        }
        OrderDishModifierItems(order_by: { createdAt: asc }) {
          count
          id
          modifierItemId
          ModifierItem {
            name
            price
            id
          }
        }
      }
    }
  }
`;
export const GET_TABLE = gql`
  query getTableDetails($tableId: uuid) {
    Table(where: { id: { _eq: $tableId } }) {
      number
    }
  }
`;

export const UPDATE_ORDER_DISH = gql`
  mutation MyMutation(
    $count: Int!
    $dishId: uuid!
    $id: uuid
    $modifierItems: [OrderDishModifierItem_insert_input!]!
    $itemsIds: [uuid!]
  ) {
    a: delete_OrderDishModifierItem(where: { id: { _nin: $itemsIds } }) {
      affected_rows
    }
    b: insert_OrderDishModifierItem(
      objects: $modifierItems
      on_conflict: {
        constraint: OrderDishModifierItem_orderDishId_modifierItemId_key
        update_columns: [count, modifierItemId] #orderDishId
      }
    ) {
      affected_rows
    }
    c: update_OrderDish(
      _set: { count: $count, dishId: $dishId }
      where: { id: { _eq: $id } }
    ) {
      returning {
        count
        createdAt
        dishId
        id
        Dish {
          name
          id
          price
          categoryId
        }
        OrderDishModifierItems(order_by: { createdAt: asc }) {
          count
          id
          modifierItemId
          ModifierItem {
            name
            price
            id
          }
        }
      }
    }
  }
`;
export const DELETE_ORDER_DISH = gql`
  mutation MyMutation($orderDishId: uuid, $orderModifierItemId: [uuid!]!) {
    a: delete_OrderDishModifierItem(
      where: {
        id: { _nin: $orderModifierItemId }
        OrderDish: { id: { _eq: $orderDishId } }
      }
    ) {
      affected_rows
    }
    b: delete_OrderDish(where: { id: { _eq: $orderDishId } }) {
      affected_rows
    }
  }
`;

export const CREATE_PAYMENT_INTENT = gql`
  mutation {
    generateStripePaymentIntent {
      clientSecret
    }
  }
`;

export const SET_ORDER_STATUS = gql`
  mutation MyMutation($orderId: uuid!, $status: String!) {
    setOrderStatus(orderId: $orderId, status: $status) {
      Order {
        id
        cache
        notes
        number
        status
        statusHistory
        total
      }
    }
  }
`;
export const UPDATE_ORDER = gql`
  mutation MyMutation($notes: String, $id: uuid) {
    update_Order(_set: { notes: $notes }, where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
